import { useEffect, useState } from "react";

const useCanvasDetection = () => {
  // State to track if the web page is displayed within a Canvas iframe
  const [isCanvas, setIsCanvas] = useState(
    localStorage.getItem("canvas") === "true"
  );

  useEffect(() => {
    const url = new URL(window.location.href);

    // Use postMessage to communicate with parent window and adjust frame height
    if (window.postMessage) {
      window.top.postMessage(
        {
          subject: "lti.frameResize",
          height: 600,
        },
        "*"
      );

      if (
        sessionStorage.getItem("canvas") &&
        sessionStorage.getItem("canvas") === "true"
        
      ) {
        setIsCanvas(true);
      } else {
        setIsCanvas(false);
      }
    }
  }, [isCanvas]); // Add isCanvas as a dependency for useEffect

  return isCanvas;
};

export default useCanvasDetection;
